import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-avatar",
  templateUrl: "./avatar.component.html",
  styleUrls: ["./avatar.component.css"],
})
export class AvatarComponent implements OnInit {
  @Input() position: number = 1; // La posición del avatar: 1, 2 o 3
  @Input() name: string = ""; // El nombre asociado al avatar
  @Input() profit: string = ""; // El nombre asociado al avatar
  @Input() avatarSize: "large" | "small" | "mid" | "default" = "default";
  @Input() backgroundImg: "";
  public borderStyle = "none";
  // public backgroundImg = "";
  @Input() starRate = false;
  get borderColor(): string {
    switch (this.position) {
      case 1:
        return "#d09f57"; // Oro
      case 2:
        return "#919191"; // Plata
      case 3:
        return "#AB3C0D"; // Bronce
      default:
        return "#CCCCCC"; // Color por defecto
    }
  }
  get iconBackgroundColor(): string {
    return this.borderColor;
  }

  get iconColor(): string {
    switch (this.position) {
      case 1:
        return "rgba(246, 208, 152, 0.96)"; // Oro claro
      case 2:
        return "rgba(219, 219, 219, 1)"; // Plata claro
      case 3:
        return "rgba(231, 151, 116, 1)"; // Bronce claro
      default:
        return "#999999"; // Color por defecto
    }
  }
  constructor() {}

  ngOnInit() {
    if (this.starRate) {
      this.borderStyle = "solid";
    }
  }
}
